export const HOME_PAGE_PREFERENCE = {
    DASHBOARD: 'DASHBOARD',
    ORIGINAL: 'ORIGINAL'
};

export const PARENT_HOME_PAGE_PREFERENCE = {
    ORIGINAL: 'ORIGINAL',
    HALO_DASHBOARD: 'DASHBOARD',
    RISK_ANALYSIS: 'DASHBOARD',
    HARRI_ENGAGE: 'DASHBOARD',
};

export const DASHBOARD_HOME_PAGE_PREFERENCE = {
    HALO_DASHBOARD: {
        id: 'HALO_DASHBOARD',
        label: $filter('translate')('Dynamic landing page')
    },
    RISK_ANALYSIS: {
        id: 'RISK_ANALYSIS',
        label: $filter('translate')('Risk analysis')
    },
    HARRI_ENGAGE: {
        id: 'HARRI_ENGAGE',
        label: $filter('translate')('Employee voice')
    }
};

export const LANGUAGES = [
    {
        id: 'EN',
        name: $filter('translate')('English'),
        label: 'en'
    },
    {
        id: 'ES',
        name: $filter('translate')('Spanish'),
        label: 'es'
    },
];

export const LANGUAGES_CODES = {
    EN: 'en',
    ES: 'es',
};